import Schema from "AppReact/schema";
import { inspectionItem } from "types";
import { array, required, obj } from 'AppReact/schema';

const category = {
  name: required('string'),
  items: array(obj(inspectionItem))
}

export default {
  category: Schema(category, "object", { defaultValue: { name: '', items: [] } }),
  hasCharges: Schema('boolean', 'primitive-nullable', { defaultValue: null })
};
